import Vue from "vue";
import VuetifyLib from "vuetify/lib";
import cs from "vuetify/src/locale/cs";
import en from "vuetify/src/locale/en";
import MaterialIcon from "@/components/MaterialIcon.component.vue";
import {
    brandAi,
    brandPrimary,
    brandPrimaryDark,
    brandSuccess,
    neutralsDark,
    neutralsLight,
    primaryFillDark,
    primaryFillLight,
    surfacesDark,
    surfacesLight,
} from "@/styles/design-tokens";

Vue.use(VuetifyLib);

export const scoreGreen = brandSuccess;
export const scoreOrange = '#d97706';
export const scoreRed = '#EA5455';

const commonColors = {
    // Brand accent for icons / borders (--v-primaryBrand-base)
    primaryBrand: brandPrimary,
    primary0:  brandPrimary,
    primary1:  brandPrimary,
    primary2:  '#319BE2',
    primary3:  '#51AAE6',
    primary4:  '#81C2ED',
    accent:    scoreGreen,
    // Semantic — same trio as the SEO score count buttons
    success:   scoreGreen,
    warning:   scoreOrange,
    error:     scoreRed,
    info:      '#00CFE8',
    // AI tones
    ai:        brandAi,
    ai1:       scoreGreen,
    ai2:       brandPrimary,
    ai3:       '#FF5C93',
    // Text markers
    markerYellow: '#f7ff00',
    markerGreen:  '#00ffb2',
    markerBlue:   '#00ffff',
    markerPink:   '#ff0056',
    // Icon colors
    tooltipIcon: '#ffffff',
};

const themes = {
    light: {
        ...commonColors,
        ...neutralsLight,
        primary:              primaryFillLight,
        greyTint:             '#8C8C8C',
        greyTintBtn:          '#757575',
        background:           surfacesLight.bg,
        surface:              surfacesLight.surface,
        blockSurface:         surfacesLight.block,
        selectedKeyword:      '#333333',
        selectedKeywordHover: '#444444',
        selectedKeywordColor: '#ffffff',
        selectedKeywordIcon:  '#ffffff',
        progressBackground:   '#bdbdbd',
    },
    dark: {
        ...commonColors,
        ...neutralsDark,
        primary:              primaryFillDark,
        primaryBrand:         brandPrimaryDark,
        primary0:             brandPrimaryDark,
        primary1:             brandPrimaryDark,
        greyTint:             neutralsDark.neutralMuted,
        greyTintBtn:          neutralsDark.neutralSubtle,
        background:           surfacesDark.bg,
        surface:              surfacesDark.surface,
        blockSurface:         surfacesDark.block,
        selectedKeyword:      '#ffffff',
        selectedKeywordHover: '#eeeeee',
        selectedKeywordColor: '#000000',
        selectedKeywordIcon:  '#333333',
        progressBackground:   '#555659',
    }
};

function missingMaterialIcons(ids: string[]) {
    const icons: Record<string, unknown> = {};
    for (const id of ids) {
        for (const suffix of ['fill', 'outline', 'two-tone', 'round', 'sharp']) {
            const name = `${id}_${suffix}`;
            icons[name] = {
                component: MaterialIcon,
                props: { name }
            };
        }
    }
    return icons;
}

const Vuetify = new VuetifyLib({
    icons: {
        iconfont: 'md',
        values: {
            ...missingMaterialIcons(['info'])
        }
    },
    lang: {
        locales: { en, cs },
        current: 'en'
    },
    theme: {
        options: {
            customProperties: true,
        },
        themes
    }
});

export { Vuetify, themes };
